import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { useMobileShell } from './lib/platform';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import RoutesPage from './pages/RoutesPage';
import RouteDetailPage from './pages/RouteDetailPage';
import ExplorePage from './pages/ExplorePage';
import PlacePage, { LegacyBarRedirect } from './pages/PlacePage';
import PlannerPage from './pages/PlannerPage';
import TripPage from './pages/TripPage';
import SharedTripPage from './pages/SharedTripPage';
import PassportPage from './pages/PassportPage';
import OwnersPage from './pages/OwnersPage';
import NotFoundPage from './pages/NotFoundPage';

// The phone layout carries MapLibre; the desktop site never downloads it.
const MobileShell = lazy(() => import('./mobile/MobileShell'));

export default function App() {
  const mobile = useMobileShell();
  if (mobile) {
    return (
      <Suspense fallback={<div className="fixed inset-0 bg-asphalt" />}>
        <MobileShell />
      </Suspense>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="routes" element={<RoutesPage />} />
        <Route path="routes/:slug" element={<RouteDetailPage />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="stops/:slug" element={<PlacePage />} />
        <Route path="bars/:slug" element={<LegacyBarRedirect />} />
        <Route path="plan" element={<PlannerPage />} />
        <Route path="my-trip" element={<TripPage />} />
        <Route path="trip/:code" element={<SharedTripPage />} />
        <Route path="passport" element={<PassportPage />} />
        <Route path="owners" element={<OwnersPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
